export const DASHBOARD_VIDEOS = "DashboardVideos";
export const CLAIMS_INFO = "ClaimsInfo";
export const ENROLMENT_INFO = "EnrolmentInfo";
export const HEALTH_DECLARATION_FORM = "HealthDeclarationForm";
export const HRARESULTS = "HRAResults";
export const MESSAGES = "Messages";
export const CLIENT_SETTINGS = "ClientSettings";
export const POINTS_SUMMARY = "PointsSummary";
export const RECOMMENDED_CONTENT = "Content";
export const NOTIFICATIONS = "Notifications";
export const ECOMMERCE = "eCommerce";
export const PASSWORD_INFO = "PasswordInfo";
export const NOTIFICATION_DOWNLOAD_CARD = "DownloadAppCard";
export const ECOMMERCE_PRODUCTS = "Products";
export const ECOMMERCE_VOUCHERS = "Vouchers";
export const INSURANCE_ADVERTISEMENT = "DashboardAdvertisements";
export const HRA_CALL_TO_ACTION = "HRACallToAction";
export const CXA_SHOP = "CXAShop";
export const SHOP_RECOMMENDATION = "ShopRecommendation";
export const PERSONAL_INSURANCE = "CXAInsuranceShop";
export const CHARITY = "Charity";



// WEBPACK FOOTER //
// ./components/dashboard/widgets/WidgetTypes.js